<script>
  import { _ } from './services/i18n'
  import { onMount, onDestroy } from 'svelte'
  import { tweened } from 'svelte/motion'
  import { cubicOut } from 'svelte/easing'

  let currentBox = 0
  const numBoxes = 5
  let reviews = [
    { title: 'reviews.reviewTitle1', text: 'reviews.review1' },
    { title: 'reviews.reviewTitle2', text: 'reviews.review2' },
    { title: 'reviews.reviewTitle3', text: 'reviews.review3' },
    { title: 'reviews.reviewTitle4', text: 'reviews.review4' },
    { title: 'reviews.reviewTitle5', text: 'reviews.review5' },
  ]

  function showBox(boxNum) {
    const boxes = document.querySelectorAll('.carousel-box')
    boxes.forEach((box, i) => {
      if (i === boxNum) {
        box.style.opacity = 1
        box.style.display = 'flex'
      } else {
        box.style.opacity = 0
        box.style.display = 'none'
      }
    })
  }

  onMount(() => {
    const leftArrow = document.querySelector('.fa-arrow-left')
    leftArrow.addEventListener('click', () => {
      currentBox = (currentBox - 1 + numBoxes) % numBoxes
      showBox(currentBox)
    })

    const rightArrow = document.querySelector('.fa-arrow-right')
    rightArrow.addEventListener('click', () => {
      currentBox = (currentBox + 1) % numBoxes
      showBox(currentBox)
    })

    showBox(currentBox)
  })
</script>

<section class="container">
  <h2 id="reviews">{$_('reviews.title')}</h2>
  <div class="carousel">
    <i class="fa-solid fa-arrow-left" />
    {#each reviews as review, i}
      <div class="carousel-box">
        <h4>{$_(review.title)}</h4>
        <p>{$_(review.text)}</p>
      </div>
    {/each}
    <i class="fa-solid fa-arrow-right" />
  </div>
</section>

<style>
  section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 1rem 10rem 1rem;
    position: relative;
  }
  h2 {
    font-size: 2rem;
    font-weight: 500;
    padding-top: 5rem;
    padding-bottom: 2rem;
  }
  .carousel {
    position: relative;
    width: 650px;
  }
  .carousel-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    box-shadow: 0px -1px 2px 0px rgba(0,0,0,0.5) inset;
  }

  p {
    text-align: center;
  }
  .fa-solid {
    font-size: 1.5rem;
    position: absolute;
  }
  .fa-arrow-left {
    top: 50%;
    left: -7px;
    transform: translateY(-50%);
  }
  .fa-arrow-right {
    top: 50%;
    right: -7px;
    transform: translateY(-50%);
  }
  @media (max-width: 768px) {
    .carousel {
      width: 100%;
    }
  }
</style>
